@file:OptIn(InternalResourceApi::class)

package ifaandroid.apps.med.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/ifaandroid.apps.med.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_859_493_881)
internal val Res.drawable.ic_calendar_clock: DrawableResource by lazy {
      DrawableResource("drawable:ic_calendar_clock", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_calendar_clock.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_375_380_402)
internal val Res.drawable.ic_checkmark_checked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_checked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_checked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(19_567_904)
internal val Res.drawable.ic_checkmark_unchecked: DrawableResource by lazy {
      DrawableResource("drawable:ic_checkmark_unchecked", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_checkmark_unchecked.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(449_530_494)
internal val Res.drawable.ic_home: DrawableResource by lazy {
      DrawableResource("drawable:ic_home", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_home.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(160_044_452)
internal val Res.drawable.ic_scroll_content: DrawableResource by lazy {
      DrawableResource("drawable:ic_scroll_content", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_scroll_content.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_752_121_504)
internal val Res.drawable.ic_speechbubble_text: DrawableResource by lazy {
      DrawableResource("drawable:ic_speechbubble_text", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_speechbubble_text.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_020_479_995)
internal val Res.drawable.ic_splash: DrawableResource by lazy {
      DrawableResource("drawable:ic_splash", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_splash.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(910_217_769)
internal val Res.drawable.ic_user: DrawableResource by lazy {
      DrawableResource("drawable:ic_user", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_user.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_calendar_clock", Res.drawable.ic_calendar_clock)
  map.put("ic_checkmark_checked", Res.drawable.ic_checkmark_checked)
  map.put("ic_checkmark_unchecked", Res.drawable.ic_checkmark_unchecked)
  map.put("ic_home", Res.drawable.ic_home)
  map.put("ic_scroll_content", Res.drawable.ic_scroll_content)
  map.put("ic_speechbubble_text", Res.drawable.ic_speechbubble_text)
  map.put("ic_splash", Res.drawable.ic_splash)
  map.put("ic_user", Res.drawable.ic_user)
}
